import { Box, Button, Menu, MenuItem, Paper, Stack, SwipeableDrawer } from "@mui/material";
import { getIntl } from "localization/intl";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const options: {
	value: string;
	label: string;
	path: string;
	color: "primary" | "success";
}[] = [
	{
		value: "my_journey",
		label: getIntl().formatMessage({
			id: "USERDASHBOARD.select_dashboard.myJourney",
			defaultMessage: "My Journey",
		}),
		path: "/user-dashboard",
		color: "primary",
	},
	{
		value: "buddy_duties",
		label: getIntl().formatMessage({
			id: "USERDASHBOARD.select_dashboard.buddyDuties",
			defaultMessage: "Buddy Duties",
		}),
		path: "/user-dashboard/buddy",
		color: "success",
	},
];

function getInitialFromWords(words: string) {
	return words
		.split(" ")
		.map((word) => word[0])
		.join("");
}

export default function SelectDashboard() {
	const location = useLocation();
	const path = location.pathname;
	const isBuddyPath = path.includes("buddy");

	const [selected, setSelected] = React.useState(isBuddyPath ? "buddy_duties" : "my_journey");
	const [drawerOpen, setDrawerOpen] = React.useState(false);
	const toggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const navigate = useNavigate();
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Box
				display={{
					xs: "block",
					md: "none",
				}}
			>
				<Button
					variant="contained"
					color={options.find((option) => option.value === selected)?.color}
					onClick={toggleDrawer}
					style={{
						fontSize: "1.6rem",
						fontWeight: "bold",
						borderRadius: "50%",
						minWidth: "auto",
						lineHeight: 1,
						width: "32px",
						height: "4rem",
						boxShadow: "none",
					}}
				>
					{getInitialFromWords(options.find((option) => option.value === selected)?.label || "")}
				</Button>
				<SwipeableDrawer
					anchor={"bottom"}
					open={drawerOpen}
					onClose={toggleDrawer}
					onOpen={toggleDrawer}
					PaperProps={{
						sx: {
							backgroundColor: "#222",
							padding: "1rem 2rem 3rem 2rem",
						},
					}}
				>
					<Box
						alignSelf="center"
						mt="1rem"
						mb="2rem"
						sx={{
							backgroundColor: "white",
							borderRadius: "0.4rem",
							width: "8rem",
							height: "4px",
						}}
					/>
					<Paper
						sx={{
							borderRadius: "1.6rem",
						}}
					>
						<Stack
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								padding: "1rem",
							}}
						>
							{options.map((option) => {
								return (
									<Stack
										direction="row"
										gap={2}
										borderBottom="1px solid #E0E0E0"
										paddingBottom="1rem"
										marginBottom="1rem"
										width="100%"
										sx={{
											"&:last-child": {
												borderBottom: "none",
												paddingBottom: 0,
												marginBottom: 0,
											},
										}}
									>
										<Button
											variant="contained"
											color={option.color}
											onClick={toggleDrawer}
											style={{
												fontSize: "1.6rem",
												fontWeight: "bold",
												borderRadius: "50%",
												minWidth: "auto",
												lineHeight: 1,
												width: "32px",
												height: "4rem",
												boxShadow: "none",
											}}
										>
											{getInitialFromWords(option.label || "")}
										</Button>
										<Button
											key={option.value}
											onClick={() => {
												navigate(option.path);
												setSelected(option.value);
												toggleDrawer();
											}}
											style={{
												padding: "2px 12px",
												fontSize: "14px",
												fontWeight: "bold",
											}}
										>
											{option.label}
										</Button>
									</Stack>
								);
							})}
						</Stack>
					</Paper>
				</SwipeableDrawer>
			</Box>
			<Box
				display={{
					xs: "none",
					md: "block",
				}}
			>
				<Button
					id="select-dashboard-button"
					aria-controls={open ? "select-dashboard-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
					onClick={handleClick}
					variant="contained"
					color={options.find((option) => option.value === selected)?.color}
					style={{
						minWidth: "11.25rem",
						fontSize: "1.6rem",
						fontWeight: "bold",
						borderRadius: "1rem",
					}}
				>
					{options.find((option) => option.value === selected)?.label}
				</Button>
				<Menu
					id="select-dashboard-menu"
					aria-labelledby="select-dashboard-button"
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					elevation={0}
					PaperProps={{
						sx: {
							borderRadius: "0.8rem",
						},
					}}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					{options.map((option) => {
						return (
							<MenuItem
								key={option.value}
								onClick={() => {
									navigate(option.path);
									setSelected(option.value);
									handleClose();
								}}
								style={{
									padding: "2px 12px",
									fontSize: "14px",
									fontWeight: "bold",
								}}
							>
								{option.label}
							</MenuItem>
						);
					})}
				</Menu>
			</Box>
		</>
	);
}
